var _circle, _circle2, _line, _ellipse, _ellipse2, _line2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7763,
    cy: 5.11635,
    r: 2.14286,
    transform: "rotate(12.8669 12.7763 5.11635)",
    fill: "#171624"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.3667,
    cy: 11.0265,
    r: 2.14286,
    transform: "rotate(12.8669 3.3667 11.0265)",
    fill: "#171624"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.6525,
    y1: 10.2248,
    x2: 11.4958,
    y2: 5.92654,
    stroke: "#171624"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.7931,
    cy: 16.8502,
    rx: 2.14235,
    ry: 2.14237,
    transform: "rotate(76.7492 12.7931 16.8502)",
    fill: "#171624"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.34634,
    cy: 11.0046,
    rx: 2.14235,
    ry: 2.14237,
    transform: "rotate(76.7492 3.34634 11.0046)",
    fill: "#171624"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 8.07934,
    y2: -0.5,
    transform: "matrix(0.850363 0.526197 -0.526206 0.850357 4.36891 12.2312)",
    stroke: "#171624"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.b30ffba9.svg";
export { ForwardRef as ReactComponent };